export default __webpack_public_path__ + "static/icon-20-3-a0a8eb1858424d4a275805fb52f10989.png";